import React, { FunctionComponent } from 'react'
import Image from 'next/image'
import classNames from 'classnames'
import styles from './LineItem.module.css'
import sharedStyles from '@/styles/templates/LineItems.module.css'
import { getDeleteClickHandler } from '@/utils/components/LineItem.utils'
import { toCurrency } from '@/utils/currency.utils'
import TXT from '@/messages'

/**
 * Order Items List
 */
export type Props = {
  /** The ticketIds associated with the lineItem */
  ticketIds: string[]

  /** The title */
  title: string

  /** The quantity */
  quantity: number

  /** The price */
  price: number

  /** whether to show the delete button or not, don't show for local items */
  showDeleteButton: boolean
  cart: Transformed.Cart

  /* the event id */
  eventSlug?: string

  /* handleDelete callback passed to getDeleteClickHandler */
  handleDelete?: (args: DeleteArgs) => void

  /* is the lineItem from events */
  isEventLineItem: boolean

  /* the lineItem data to render */
  lineItem: Transformed.LineItem
}

/**
 * This component contains the line item mark up
 */
const LineItem: FunctionComponent<Props> = ({
  title,
  quantity,
  price,
  ticketIds,
  cart,
  showDeleteButton,
  eventSlug = undefined,
  handleDelete = undefined,
  isEventLineItem,
  lineItem,
}: Props) => {
  const total = price
  const handleDeleteClick = getDeleteClickHandler(lineItem, ticketIds, isEventLineItem, handleDelete, cart)

  const titleProps = {
    className: classNames('title', styles.Title, { events: isEventLineItem }),
    'data-testid': 'line-item-title',
    title: eventSlug ? TXT.cartSummary.goToEventDetails : '',
  }

  return (
    <>
      <div
        className={classNames(
          styles.LineItem,
        )}
        data-testid="line-item"
      >
        <div className="line-item-content">
          <div>
            <span {...titleProps}>
              {title}
            </span>
            <span className={styles.Quantity} data-testid="line-item-quantity">{TXT.cartSummary.quantity(quantity)}</span>
          </div>

        </div>
        <div
          className={classNames(
            styles.Price,
            { [styles.Bold]: showDeleteButton },
            { [styles.PlaceThird]: !showDeleteButton },
          )}
          data-testid="price"
        >
          {toCurrency(total, 2)}

        </div>
        {showDeleteButton && (
          <button
            type="button"
            className={classNames(
              'btn-unstyled',
              sharedStyles.RemoveLink,
            )}
            data-testid="remove-line-item"
            onClick={handleDeleteClick}
            aria-label={TXT.a11y.removeTicketsFromCart(quantity, title)}
          >
            <Image
              width={13}
              height={13}
              src="/static/svg/close.svg"
              alt="close"
            />
          </button>
        )}
      </div>
    </>
  )
}

export default LineItem
